<template>
    <div name="apply" class="wrapper">
        <loading v-if="isLoading" />
        <address-modal 
            v-if="isAddressInputModal"
            @onClose="closeAddressInputModal"
            @apply="addressApply"
            :preAddress="this.diabetes_profiles[this.activeProfileId].profile.address"
            :preDetailAddress="this.diabetes_profiles[this.activeProfileId].profile.detail_address"
            :preAddressNickname="this.diabetes_profiles[this.activeProfileId].profile.address_nickname"
            :preZipCode="this.diabetes_profiles[this.activeProfileId].profile.zip_code"
            :preAddressDescription="this.diabetes_profiles[this.activeProfileId].profile.address_description"
            :isUpdate="isRegistered()"
        />
        <card-change-modal 
            :token="token"
            v-if="isCardChangeModal"
            @onClose="onCloseCardChangeModal"
            :profile_id="profileId"
        />
        <common-modal 
            v-if="isCardDeleteModal"
            :title="'카드 삭제 안내'"
            :message="'삭제 후엔 되돌릴 수 없어요.<br>정말로 삭제하시겠습니까?'"
            :button1Text="'네, 삭제해주세요'"
            :button2Text="'아니요'"
            :buttonCount="2"
            @onClose="closeCardDeleteModal"
            @onClickButton1="deleteCardCall"
            @onClickButton2="closeCardDeleteModal"
        />
        <div class="page" v-else-if="diabetes_profiles[activeProfileId]">
            <error-modal 
                v-if="error"
                :error="error"
                @onClose="onErrorModalClose"
            />
            <div class="button-header">
                <img @click="back" style="width: 22px; cursor: pointer;" src="../assets/arrow_back.png" />
            </div>
            <div class="contents-header">
                <span class="text1">환자정보 관리</span>
                <span class="text2" style="margin-top: 16px;">환자를 선택하면<br><span class="text3">등록된 정보</span>를 확인할 수 있어요</span>
            </div>
            <div class="contents-body">
                <div class="register-button" @click="goRegister">
                    <span class="text4">👉🏻 <strong>환자 추가</strong>가 필요하세요?</span>
                    <div class="row">
                        <span class="text5">추가하기</span>
                        <img style="width: 22px;" src="../assets/right_arrow3.png" />
                    </div>
                </div>              
                <text-label 
                    :text="'환자선택'"
                    :isDefault="false"
                />
                <div class="name-button-list">
                    <div v-for="(info, index) in diabetes_profiles" style="margin-right: 16px;">
                        <div class="name-button-active" v-if="activeProfileId === index">
                            {{ info.profile.name }}
                        </div>
                        <div class="name-button-inactive" v-else @click="selectProfile(index)">
                            {{ info.profile.name }}
                        </div>
                    </div>
                </div>

                <div class="line"></div>

                <tabs 
                    :list="tabList"
                    :selectedIndex="selectedTabIndex"
                    @onClick="selectTab"
                    style="margin-top: 20px;"
                />
                <div style="width: 100%;" v-if="selectedTabIndex === 0">                    
                    <text-label 
                        :text="'휴대폰번호'"
                        :isDefault="true"
                    />
                    <input 
                        v-model="phoneNumber"
                        inputmode="numeric"
                        v-focus-background
                        class="input-big"
                        placeholder="진료 받으실 분의 휴대폰번호를 적어주세요"
                        ref="phone"
                    />
                    <div class="row" style="margin-top: 8px;justify-content: flex-start;">
                        <span class="info-text">진료 시간이 되면 <span class="info-color-text">의사가 전화로 연락</span>드려요</span>
                    </div>
                    <div class="error-info-text">{{ phoneError }}</div>   
                    <div class="save-button" style="margin-top: 8px;" @click="updatePhoneNumber">저장</div>

                    <div class="line"></div>

                    <text-label 
                        :text="'등록된 결제 카드'"
                        :isDefault="false"
                    />
                    <div class="card-area" v-if="diabetes_profiles[activeProfileId].card_info != null">                     
                        <span class="text6">{{ diabetes_profiles[activeProfileId].card_info.card_name }}</span>
                        <span class="text7" style="margin-top: 11px;">{{ diabetes_profiles[activeProfileId].card_info.card_number }}</span>                    
                        <div class="row" style="margin-top: 14px; gap: 8px">
                            <div class="card-update-button" @click="changeCard">변경</div>
                            <div class="card-update-button" @click="deleteCard">삭제</div>
                        </div> 
                    </div>
                    <div class="plus-button" v-else style="margin-top: 16px;" @click="changeCard">
                        <img style="width: 22px;" src="../assets/plus_btn.png" />
                        <span style="margin-left: 16px;">결제카드 등록</span>
                    </div>
                    <div class="row" style="margin-top: 8px;justify-content: flex-start;">
                        <span class="info-color-text">진료비/조제비 및 물품 결제<span class="info-text">시 사용돼요</span></span>
                    </div>  
                    <div class="line"></div>

                    <text-label 
                        :text="'배송지 정보'"
                        :isDefault="false"
                    />
                    <span class="info-text" v-if="!isRegistered()">배송지를 미리 등록해 두시면 결제부터 배송까지 더욱 빠르게 이용하실 수 있어요</span>
                    <div class="plus-button" v-if="!isRegistered()" style="margin-top: 16px;" @click="inputAddress">
                        <img style="width: 22px;" src="../assets/plus_btn.png" />
                        <span style="margin-left: 16px;">배송지 등록</span>
                    </div>
                    <address-card 
                        v-else
                        @updateAddress="inputAddress"
                        :address="diabetes_profiles[activeProfileId].profile.address"
                        :detailAddress="diabetes_profiles[activeProfileId].profile.detail_address"
                        :zipCode="diabetes_profiles[activeProfileId].profile.zip_code"
                        :addressNickname="diabetes_profiles[activeProfileId].profile.address_nickname"
                        :addressDescription="diabetes_profiles[activeProfileId].profile.address_description"
                    />
                </div>
                <div v-else-if="selectedTabIndex === 1" style="width: 100%;">
                    <!-- 위임정보가 없는 경우 -->
                    <div v-if="diabetes_profiles[activeProfileId].delegation_info === null" style="width: 100%; margin-top: 20px;">
                        <span class="title" >💡 질환 유형</span>
                        <div class="text-box" style="margin-bottom: 8px;">
                            <span class="text" v-if="diabetes_profiles[activeProfileId].profile.diabetes_type === 'TYPE1'">1형 당뇨</span>
                            <span class="text" v-else-if="diabetes_profiles[activeProfileId].profile.diabetes_type === 'GESTATIONAL'">임신성 당뇨 (인슐린 투여)</span>
                            <span class="text" v-else-if="diabetes_profiles[activeProfileId].profile.diabetes_type === 'GESTATIONAL_WITHOUT_INSULIN'">임신성 당뇨 (인슐린 미투여)</span>
                            <span class="text" v-else-if="diabetes_profiles[activeProfileId].profile.diabetes_type === 'SELF_CATHETER'">자가도뇨 카테터 대상자</span>
                            <span class="text" v-else>2형 당뇨</span>
                        </div>
                        <span class="title">💡 청구 위임 정보</span>
                        <div class="text-box">
                            <span class="label" style="color: var(--Gray-50, #A3AAB6);">위임 정보가 확인되지 않습니다.</span>                        
                        </div>
                            <!-- next -->
                        <bottom-button 
                            v-if="isDelegationWritable"                     
                            :text="'위임장 작성하기'"
                            :color="'var(--Gray-100, #1E1E1E)'"
                            @onClick="goContractNew"
                            style="margin-top: 40px;"
                        />   
                    </div>
                    <!-- 위임정보가 없는 경우 -->
                    <div v-else-if="!diabetes_profiles[activeProfileId].delegation_info.is_delegated" style="width: 100%; margin-top: 20px;">
                        <span class="title" >💡 질환 유형</span>
                        <div class="text-box" style="margin-bottom: 8px;">
                            <span class="text" v-if="diabetes_profiles[activeProfileId].profile.diabetes_type === 'TYPE1'">1형 당뇨</span>
                            <span class="text" v-else-if="diabetes_profiles[activeProfileId].profile.diabetes_type === 'GESTATIONAL'">임신성 당뇨 (인슐린 투여)</span>
                            <span class="text" v-else-if="diabetes_profiles[activeProfileId].profile.diabetes_type === 'GESTATIONAL_WITHOUT_INSULIN'">임신성 당뇨 (인슐린 미투여)</span>
                            <span class="text" v-else-if="diabetes_profiles[activeProfileId].profile.diabetes_type === 'SELF_CATHETER'">자가도뇨 카테터 대상자</span>
                            <span class="text" v-else>2형 당뇨</span>
                        </div>
                        <span class="title">💡 청구 위임 정보</span>
                        <div class="text-box">
                            <span class="label" style="color: var(--Gray-50, #A3AAB6);">위임 정보가 확인되지 않습니다.</span>                        
                        </div>
                        <!-- next -->
                        <bottom-button 
                        v-if="isDelegationWritable"                     
                            :text="'위임장 작성하기'"
                            :color="'var(--Gray-100, #1E1E1E)'"
                            @onClick="goContractNew"
                            style="margin-top: 40px;"
                        />   
                    </div>

                    <!-- 위임정보가 있는 경우 -->
                    <div v-else style="width: 100%; margin-top: 20px;">
                        <span class="title" >💡 질환 유형</span>
                        <div class="text-box" style="margin-bottom: 8px;">
                            <span class="text" v-if="diabetes_profiles[activeProfileId].profile.diabetes_type === 'TYPE1'">1형 당뇨</span>
                            <span class="text" v-else-if="diabetes_profiles[activeProfileId].profile.diabetes_type === 'GESTATIONAL'">임신성 당뇨 (인슐린 투여)</span>
                            <span class="text" v-else-if="diabetes_profiles[activeProfileId].profile.diabetes_type === 'GESTATIONAL_WITHOUT_INSULIN'">임신성 당뇨 (인슐린 미투여)</span>
                            <span class="text" v-else-if="diabetes_profiles[activeProfileId].profile.diabetes_type === 'SELF_CATHETER'">자가도뇨 카테터 대상자</span>
                            <span class="text" v-else>2형 당뇨</span>
                        </div>
                        <span class="title">💡 청구 위임 정보</span>
                        <div class="text-box" >
                            <div style="display: flex; justify-content: space-between; align-items: center;">
                                <span class="label">위임 기간 (최대 5년)</span>
                                <div class="red-tag" v-if="duplicateDelegation">만료예정</div>
                                <div class="black-tag" v-if="expireDelegation">기간만료</div>
                            </div>
                           
                            <span class="text">{{ convertDate(diabetes_profiles[activeProfileId].delegation_info.started_at) }} ~ {{ convertDate(diabetes_profiles[activeProfileId].delegation_info.expired_at) }}</span>
                            <span class="label" style="margin-top: 16px;">위임일</span>
                            <span class="text" v-if="diabetes_profiles[activeProfileId].delegation_info.is_delegated">{{ convertDate(diabetes_profiles[activeProfileId].delegation_info.started_at) }}</span>
                            <span class="label" style="margin-top: 20px;">위임사항</span>
                            <span v-if="diabetes_profiles[activeProfileId].profile.diabetes_type !== 'SELF_CATHETER'" class="text">당뇨병 소모성재료, 연속혈당측정용 전극(센서)<span v-if="diabetes_profiles[activeProfileId].profile.diabetes_type === 'TYPE1'">, 연속혈당측정기, 인슐린자동주입기</span></span>
                            <span class="text" v-else>자가도뇨 소모성 재료</span>
                        </div>

                        <!-- 만료임박 버튼 -->
                        <div style="width: 100%;">   
                            <div class="text-box" style="margin-top: 8px;" v-if="duplicateDelegation" >
                                <span class="text-red">❗️청구 위임 기간이 곧 만료됩니다.<br>
                                    <span class="text-normal">만료 후에는 자동 해지 되므로 연장을 위해 위임장을 새로 작성해 주세요.</span>
                                </span>                                
                            </div>
                            <!-- next -->
                            <bottom-button 
                                v-if="(duplicateDelegation || expireDelegation) && isDelegationWritable" 
                                :text="'위임장 작성하기'"
                                :color="'var(--Gray-100, #1E1E1E)'"
                                @onClick="goContractWithDelegationInfo"
                                style="margin-top: 40px;"
                            />   
                        </div> 
  
                    </div>

                </div>
                <!-- 구매 조건 -->
                <div style="width: 100%; display: flex; flex-direction: column;" v-else>
                    <span class="title" style="margin-top: 20px;">구매 가능일</span>
                    <span class="text6" style="margin-top: 8px;">구매주기를 놓치지 않도록, 솔닥 컨시어지가 챙겨드립니다!<br><span class="text7">공단에서 문자로 안내받은 날짜</span>로 입력해 주세요. </span>
                    <div style="margin-top: 20px;display: flex; flex-direction: column;" v-if="diabetes_profiles[activeProfileId].profile.diabetes_type !== 'SELF_CATHETER'">
                        <span class="text-20-400-1E1E1E">전극</span>
                        <div class="input-calendar-wrapper" style="margin-top: 9px;">
                            <input
                                class="input-calendar"
                                ref="dateInput1"
                                v-model="electrode_date"
                                v-focus-background
                                placeholder="날짜를 선택해주세요"
                                readonly
                                @click="openDatePicker1"
                            />
                            <span v-if="electrode_date" class="clear-btn" @click.stop="clearElectrodeDate">×</span>
                        </div>
                        <date-picker-modal
                            v-if="showDatePicker1"
                            :initialDate="electrode_date"
                            @onClose="closeDatePicker1"
                            @onConfirm="confirmDatePicker1"
                        />
                        <span class="text-20-400-1E1E1E" style="margin-top: 20px;">소모성재료</span>
                        <div class="input-calendar-wrapper" style="margin-top: 9px;">
                            <input
                                class="input-calendar"
                                ref="dateInput2"
                                v-model="expendable_date"
                                v-focus-background
                                placeholder="날짜를 선택해주세요"
                                readonly
                                @click="openDatePicker2"
                            />
                            <span v-if="expendable_date" class="clear-btn" @click.stop="clearExpendableDate">×</span>
                        </div>
                        <date-picker-modal
                            v-if="showDatePicker2"
                            :initialDate="expendable_date"
                            @onClose="closeDatePicker2"
                            @onConfirm="confirmDatePicker2"
                        />
                    </div>
                    <div v-else style="margin-top: 20px;">
                        <span class="text-20-400-1E1E1E" >카테터</span>
                        <div class="input-calendar-wrapper" style="margin-top: 9px;">
                            <input
                                class="input-calendar"
                                ref="dateInput2"
                                v-model="catheter_date"
                                v-focus-background
                                placeholder="날짜를 선택해주세요"
                                readonly
                                @click="openDatePicker3"
                            />
                            <span v-if="catheter_date" class="clear-btn" @click.stop="clearCatheterDate">×</span>
                        </div>
                        <date-picker-modal
                            v-if="showDatePicker3"
                            :initialDate="catheter_date"
                            @onClose="closeDatePicker3"
                            @onConfirm="confirmDatePicker3"
                        />
                    </div>

                    
                    <div class="line"></div>
                    <span class="text-20-600-1E1E1E" style="margin-top: 20px;" >경감 대상 선택</span>
                    <radio-button-list 
                        style="margin-top: 16.5px;"
                        :labelList="['해당없음', '기초생활수급자', '차상위계층']"
                        :selectedIndex="selectedSaleType"
                        @select="selectSaleType"
                        ref="type"
                    />
                   <div style="width: 100%;" v-if="diabetes_profiles[activeProfileId].profile.diabetes_type !== 'SELF_CATHETER'">
                        <div class="line"></div>
                        <span class="text-20-600-1E1E1E" style="margin-top: 20px;">인슐린펌프 사용 여부</span>
                        <span class="text-18-400-1E1E1E" style="color: #1E1E1E;margin-top: 8px;">만 19세 미만 미니메드 780G 인슐린펌프 사용자의 경우 공단 지원금이 다를 수 있습니다.</span>
                        <div class="row" style=" margin-top: 8px;justify-content: flex-start;">
                            <check-box 
                                :checked="useAutoInjector"
                                @onClick="() => useAutoInjector = !useAutoInjector"
                            />
                            <span class="text-18-400-1E1E1E" style="margin-left: 16px;">미니메드 780G 사용</span>            
                        </div>
                        
                   </div>
                   <div class="footer-button-area">
                        <bottom-button 
                            :text="'저장하기'"
                            :color="'var(--Gray-100, #1E1E1E)'"
                            @onClick="saveAdditionInfo"
                            style="margin-top: 40px;"
                        />   
                    </div>
                </div>
                <div class="floating" v-if="isFloating">
                    {{ floatingMessage }}
                    <img class="close" @click="closeFloating" src="../assets/float-close.png" />
                </div>
               
                
            </div>
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex';
import TextLabel from '@/components/atoms/TextLabel';
import focusBackground from '@/components/directives/focusBackground';
import BottomButton from '@/components/atoms/BottomButton';
import Constant from '@/constant';
import CardChangeModal from '@/components/modals/CardChangeModal';
import Loading from '@/components/molecules/Loading';
import ErrorModal from '@/components/modals/ErrorModal';
import cookies from '@/utilities/cookie.js';
import Validation from '@/utilities/validation';
import AddressCard from '@/components/molecules/AddressCard';
import AddressModal from '@/components/modals/AddressModal';
import Tabs from '@/components/molecules/Tabs';
import RadioButtonList from '@/components/molecules/RadioButtonList';
import CommonModal from '@/components/modals/CommonModal';
import CheckBox from '@/components/atoms/CheckBox.vue'
import DatePickerModal from '@/components/modals/DatePickerModal';

export default {
    name: 'apply',
    computed: {
        ...mapState(['diabetes_profiles', 'delivery', 'cardInfo', 'delegateWithAddition', 'draftProfile']),
        // 유형별 탭 구성
        // 희귀난치성질환은 기본 정보만, 자가도뇨 카테터는 구매조건 탭을 임시로 숨긴다
        tabList: function()
        {
            const profile = this.diabetes_profiles[this.activeProfileId];
            const type = profile ? profile.profile.diabetes_type : null;

            if(type === 'RARE_INTRACTABLE')
            {
                return ['기본 정보'];
            }
            if(type === 'SELF_CATHETER')
            {
                return ['기본 정보', '위임 정보'];
            }
            return ['기본 정보', '위임 정보', '구매조건'];
        },
        // 위임장을 쓸 수 있는 유형인지
        // 임신성 당뇨(인슐린 미투여), 2형 당뇨, 자가도뇨 카테터는 위임장을 쓰지 않는다
        isDelegationWritable: function()
        {
            const profile = this.diabetes_profiles[this.activeProfileId];
            if(!profile)
            {
                return false;
            }
            return profile.profile.diabetes_type !== 'GESTATIONAL_WITHOUT_INSULIN'
                && profile.profile.diabetes_type !== 'TYPE2'
                && profile.profile.diabetes_type !== 'SELF_CATHETER';
        }
    },
    components: {
        TextLabel,
        BottomButton,
        CardChangeModal,
        Loading,
        ErrorModal,
        AddressCard,
        AddressModal,
        Tabs,
        CommonModal,
        RadioButtonList,
        CheckBox,
        DatePickerModal
    },
    directives: {
        focusBackground        
    },
    data: function()
    {
        return {
            activeProfileId: 0,
            token: null,
            isCardChangeModal: false,
            isLoading: false,
            error: null,
            phoneError: null,
            isAddressInputModal: false,
            profileId: 0,
            selectedTabIndex: 0,
            isCardDeleteModal: false,
            duplicateDelegation: false,
            expireDelegation: false,
            selectedSaleType: 0,
            expendable_date: null,
            electrode_date: null,
            useAutoInjector: false,
            electrode_first: false,
            isFloating: false,
            floatingMessage: '',
            phoneNumber: null,
            showDatePicker1: false,
            showDatePicker2: false,
            showDatePicker3: false,
            catheter_date: null
        }
    },
    mounted: function()
    {

        ChannelIO('shutdown')
        this.token = cookies.getLocalStorage("access_token");
        if(this.token === null || this.token === undefined || this.token === '')
        {
            this.token = cookies.deleteLocalStorage("access_token");
            this.$router.push({path: '/', query: {returnUrl: 'apply'}})
        }
        else
        {
             this.$store.dispatch(Constant.FETCH_PROFILES, {token: this.token})
                .then((res) => {
                    this.phoneNumber = this.diabetes_profiles[this.activeProfileId].profile.phone_number;
                })
                .catch(() => {

                })
        }
    },
    methods: {
        normalizeToYYYYMMDDOrKeep: function (input) {
            var original = (input == null) ? "" : String(input);
            var s0 = original.trim();
            if (!s0) return original;

            // 숫자와 구분자(.,-)만 남기기
            var s = s0.replace(/[^\d.-]/g, "");

            // 1) 숫자만: YYYYMMDD
            var digits = s.replace(/[.-]/g, "");
            if (/^\d{8}$/.test(digits)) {
                var y = digits.slice(0, 4);
                var m = digits.slice(4, 6);
                var d = digits.slice(6, 8);
                var r1 = this.validateAndFormatStrict(y, m, d);
                return (r1 !== null && r1 !== undefined) ? r1 : original;
            }

            // 2) 연도 + 나머지: 2025-0101, 202501.01, 2025.01.01, 2025-01-01 등
            //    (불완전 입력: 2025-1 / 2025-01-1 / 2025-01-0 등은 보정하지 않고 그대로)
            var yearMatch = s.match(/^(\d{4})[.-]?(.+)$/);
            if (yearMatch) {
                var y2 = yearMatch[1];
                var rest = yearMatch[2];

                // rest가 "1" 이거나 "01-1" 같은 불완전이면 그대로 반환하기 위해
                // 월/일을 '정확히 2자리'로만 인정한다.
                var parts = rest.split(/[.-]+/).filter(Boolean);

                // 케이스: 2025-01-01, 2025.01.01
                if (parts.length >= 2 && /^\d{2}$/.test(parts[0]) && /^\d{2}$/.test(parts[1])) {
                var r2 = this.validateAndFormatStrict(y2, parts[0], parts[1]);
                return (r2 !== null && r2 !== undefined) ? r2 : original;
                }

                // 케이스: 2025-0101, 202501.01 (연도 뒤 나머지 숫자가 정확히 4자리면 MMDD로 인정)
                var restDigits = rest.replace(/[^\d]/g, "");
                if (/^\d{4}$/.test(restDigits)) {
                var m2 = restDigits.slice(0, 2);
                var d2 = restDigits.slice(2, 4);
                var r3 = this.validateAndFormatStrict(y2, m2, d2);
                return (r3 !== null && r3 !== undefined) ? r3 : original;
                }
            }

            // 그 외는 그대로
            return original;
        },
        /* ---------- helpers ---------- */
        validateAndFormatStrict: function (y, m, d) {
            if (!/^\d{4}$/.test(String(y))) return null;
            if (!/^\d{2}$/.test(String(m))) return null;
            if (!/^\d{2}$/.test(String(d))) return null;

            var year = Number(y);
            var month = Number(m);
            var day = Number(d);

            if (year < 1900 || year > 2100) return null;
            if (month < 1 || month > 12) return null;

            var lastDay = new Date(year, month, 0).getDate();
            if (day < 1 || day > lastDay) return null;

            return y + "-" + m + "-" + d;
        },
        isValidYYYYMMDD: function (dateStr) {
            if (typeof dateStr !== "string") return false;

            // 형식 체크
            if (!/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) return false;

            var parts = dateStr.split("-");
            var year = Number(parts[0]);
            var month = Number(parts[1]);
            var day = Number(parts[2]);

            // 월 범위
            if (month < 1 || month > 12) return false;

            // 해당 월의 마지막 날 (윤년 포함)
            var lastDay = new Date(year, month, 0).getDate();

            // 일 범위
            if (day < 1 || day > lastDay) return false;

            return true;
        },
        openDatePicker() {
            const input = this.$refs.dateInput;

            // 최신 크롬 / 사파리
            if (input.showPicker) {
                input.showPicker();
            } else {
                // 구형 브라우저 대응
                input.focus();
                input.click();
            }
        },
        openDatePicker1: function()
        {
            this.showDatePicker1 = true;
        },
        closeDatePicker1: function()
        {
            this.showDatePicker1 = false;
        },
        confirmDatePicker1: function(date)
        {
            this.electrode_date = date;
            this.showDatePicker1 = false;
        },
        confirmDatePicker3: function(date)
        {
            this.catheter_date = date;
            this.showDatePicker3 = false;
        },
        openDatePicker2: function()
        {
            this.showDatePicker2 = true;
        },
        openDatePicker3: function()
        {
            this.showDatePicker3 = true;
        },
        closeDatePicker2: function()
        {
            this.showDatePicker2 = false;
        },
        closeDatePicker3: function()
        {
            this.showDatePicker3 = false;
        },
        confirmDatePicker2: function(date)
        {
            this.expendable_date = date;
            this.showDatePicker2 = false;
        },
        clearElectrodeDate: function()
        {
            this.electrode_date = null;
        },
        clearExpendableDate: function()
        {
            this.expendable_date = null;
        },
        clearCatheterDate: function()
        {
            this.catheter_date = null;
        },
        selectSaleType (type) {
            this.selectedSaleType = type;
        },
        convertDate: function(date)
        {   
            return `${date.substring(0, 4)}년 ${date.substring(5, 7)}월 ${date.substring(8, 10)}일`;
        },
        updatePhoneNumber: function()
        {
            // 휴대전화 번호 정규식 확인 필요 
            this.diabetes_profiles[this.activeProfileId].profile.phone_number = this.phoneNumber;
            if(this.diabetes_profiles[this.activeProfileId].profile.phone_number == '')
            {
                this.errorFocus('phone');
                this.phoneError = '휴대폰번호를 입력해 주세요.';
                return;
            }


            if(!Validation.isValidPhoneNumber(this.diabetes_profiles[this.activeProfileId].profile.phone_number))
            {
                this.errorFocus('phone')
                this.phoneError = '유효한 휴대폰번호 형식이 아닙니다.';
                return;
            }


            this.isLoading = true;
            this.$store.dispatch(Constant.UPDATE_PROFILE, {
                phoneNumber: this.diabetes_profiles[this.activeProfileId].profile.phone_number,
                profile_id: this.diabetes_profiles[this.activeProfileId].profile.id,
                token: this.token
            })
            .then(() => {
                this.isLoading = false;
                this.setFloatingMessage('저장되었습니다.')
            })
            .catch(() => {
                this.isLoading = false;
            })
        },
       
        convertDiabetesTypes: function(type)
        {
            if(type === 'TYPE1')
            {
                return '1형 당뇨'
            }
            else if(type === 'GESTATIONAL')
            {
                return '임신성 당뇨 (인슐린 투여)'
            }
            else if(type === 'GESTATIONAL_WITHOUT_INSULIN')
            {
                return '임신성 당뇨 (인슐린 미투여)'
            }
            else
            {
                return '2형 당뇨'
            }
        },
        isRegistered: function()
        {
            if(this.diabetes_profiles[this.activeProfileId].profile.address === null)
            {
                return false;
            }
            else {
                return true;
            }
        },
        closeAddressInputModal: function()
        {
            this.isAddressInputModal = false;
        },
        inputAddress: function()
        {
            this.isAddressInputModal = true;
        },
        addressApply: function(address, detailAddress, addressNickname, zipCode, addressDescription)
        {
            this.isAddressInputModal = false;
            this.isLoading = true;


            this.$store.commit(Constant.INITIALIZE_DELIVERY)
            this.delivery.address = address
            this.delivery.detail_address = detailAddress;
            this.delivery.zip_code = zipCode;
            this.delivery.address_nickname = addressNickname;
            this.delivery.address_description = addressDescription;

            
            this.$store.dispatch(Constant.UPDATE_DELIVERY, {profile_id: this.diabetes_profiles[this.activeProfileId].profile.id, token: this.token})
                .then(() => {
                     // reload
                    this.setFloatingMessage('저장되었습니다.')
                     this.$store.dispatch(Constant.FETCH_PROFILES, {token: this.token})
                        .then(() => {
                            this.isLoading = false;
                        }) 
                        .catch(() => {
                            this.token = cookies.deleteLocalStorage("access_token");
                            this.isLoading = false;
                            this.$router.push({path: '/', query: {returnUrl: 'apply'}})
                        })
                })
                .catch((err) => {
                    this.isLoading = false;
                })
        },
        onErrorModalClose: function()
        {
            this.error = null;
        },
        goRegister: function()
        {
            this.$router.push({path: '/register'})
        },
        selectTab: function(index)
        {    
            if(this.selectedTabIndex === 0)
            {
                this.$refs['phone'].style.border = '1px solid var(--gray-40-button-stroke, #D1D6DB)';
            }
           
            this.selectedTabIndex = index;
        },
        selectProfile: function(index)
        {
            if(this.selectedTabIndex === 0)
            {
                this.$refs['phone'].style.border = '1px solid var(--gray-40-button-stroke, #D1D6DB)';
            }
            
            this.activeProfileId = index
            this.phoneNumber = this.diabetes_profiles[this.activeProfileId].profile.phone_number
            this.duplicateDelegation = false;
            this.expireDelegation = false;
        }, 
        errorFocus: function(field)
        {
            this.$refs[field].style.border = '1.5px solid var(--Semantic-01_Red, #FF000F)';

            const offsetTop = this.$refs[field].offsetTop;
                window.scrollTo({
                    top: offsetTop - 50, // 50px 위로 조정
                    behavior: 'smooth'
            });
        },
        changeCard: function()
        {
            this.$store.commit(Constant.INITIALIZE_CARD_INFO);
            this.profileId = this.diabetes_profiles[this.activeProfileId].profile.id;
            this.isCardChangeModal = true;
        },
        deleteCard: function()
        {
            this.profileId = this.diabetes_profiles[this.activeProfileId].profile.id;
            this.isCardDeleteModal = true;
        },
        closeCardDeleteModal() {
            this.isCardDeleteModal = false;
        },
        deleteCardCall() {
            this.isLoading = true;
            // 삭제 수행 
            this.$store.dispatch(Constant.DELETE_CARD, {profile_id: this.profileId, token: this.token})
                .then(() => {
                    this.isCardDeleteModal = false;
                    this.isLoading = false;
                    this.setFloatingMessage('삭제되었습니다.')

                    this.$store.dispatch(Constant.FETCH_PROFILES, {token: this.token})
                        .then(() => {
                            this.isLoading = false;
                        }) 
                        .catch(() => {
                            this.token = cookies.deleteLocalStorage("access_token");
                            this.isLoading = false;
                            this.$router.push({path: '/', query: {returnUrl: 'apply'}})
                        })

                }) 
                .catch(() => {
                    this.isLoading = false;
                    this.token = cookies.deleteLocalStorage("access_token");
                    this.$router.push({path: '/', query: {returnUrl: 'apply'}})
                })
        },
        onCloseCardChangeModal: function(flag)
        {

            if(flag)
            {
                this.setFloatingMessage('저장되었습니다.')
            }

            this.isLoading = true;
            this.$store.dispatch(Constant.FETCH_PROFILES, {token: this.token})
                .then(() => {
                    this.isLoading = false;
                }) 
                .catch(() => {
                    this.isLoading = false;
                    this.token = cookies.deleteLocalStorage("access_token");
                    this.$router.push({path: '/', query: {returnUrl: 'apply'}})
                })
            this.isCardChangeModal = false;
        },
        goContractWithDelegationInfo: function()
        {
            // profile 생성 
            this.$store.commit(Constant.FETCH_PRE_DELEGATION_INFO, {
                pre_delegation_info: this.diabetes_profiles[this.activeProfileId].delegation_info,
                is_loading: true,
                profile_id: this.diabetes_profiles[this.activeProfileId].profile.id

            })
            this.diabetes_profiles[this.activeProfileId].profile.phone_number = this.phoneNumber;
            const tempProfile = this.diabetes_profiles[this.activeProfileId].profile;
            //draft 생성 
            this.$store.commit(Constant.INITIALIZE_DRAFT_PROFILE)
            this.draftProfile.diabetes_type = tempProfile.diabetes_type;
            this.draftProfile.name = tempProfile.name;
            this.draftProfile.registration_number = tempProfile.registration_number;
            this.draftProfile.phone_number = tempProfile.phone_number;
            this.draftProfile.address = tempProfile.address;
            this.draftProfile.detail_address = tempProfile.detail_address;
            this.draftProfile.zip_code = tempProfile.zip_code;
            this.draftProfile.address_nickname = tempProfile.address_nickname;
            this.draftProfile.address_description = tempProfile.address_description;
            this.draftProfile.agreement_personal_info = true
            this.draftProfile.agreement_sensitive_info = true;
    

            this.$router.push({path: '/revisit'})
        },
        goContractNew: function()
        {
            this.$store.commit(Constant.FETCH_PRE_DELEGATION_INFO, {
                pre_delegation_info: {is_delegated: false, started_at: null, expired_at: null},
                is_loading: true,
                profile_id: this.diabetes_profiles[this.activeProfileId].profile.id

            })
            this.diabetes_profiles[this.activeProfileId].profile.phone_number = this.phoneNumber;
            const tempProfile = this.diabetes_profiles[this.activeProfileId].profile;
            //draft 생성 
            this.$store.commit(Constant.INITIALIZE_DRAFT_PROFILE)
            this.draftProfile.diabetes_type = tempProfile.diabetes_type;
            this.draftProfile.name = tempProfile.name;
            this.draftProfile.registration_number = tempProfile.registration_number;
            this.draftProfile.phone_number = tempProfile.phone_number;
            this.draftProfile.address = tempProfile.address;
            this.draftProfile.detail_address = tempProfile.detail_address;
            this.draftProfile.zip_code = tempProfile.zip_code;
            this.draftProfile.address_nickname = tempProfile.address_nickname;
            this.draftProfile.address_description = tempProfile.address_description;
            this.draftProfile.agreement_personal_info = true
            this.draftProfile.agreement_sensitive_info = true;


            this.$router.push({path: '/revisit'})
        },
        saveAdditionInfo: function()
        {
            // 추가 정보 입력 관련 
            this.$store.commit(Constant.INITIALIZE_DELEGATE_WITH_ADDITION)
            this.delegateWithAddition.additional_info.is_injection_insulin = this.useAutoInjector;
            this.delegateWithAddition.additional_info.person_type = this.selectedSaleType === 0 ? null : this.selectedSaleType === 1 ? 'NATIONAL_BASIC' : this.selectedSaleType === 2 ? 'LOW_INCOME' : null;
            
        
            this.delegateWithAddition.additional_info.electrode_date = this.electrode_date;
            this.delegateWithAddition.additional_info.expendable_date = this.expendable_date;
            this.delegateWithAddition.additional_info.catheter_date = this.catheter_date;

            if(this.delegateWithAddition.additional_info.electrode_date  === '')
            {
                this.delegateWithAddition.additional_info.electrode_date = null;
            }
            if(this.delegateWithAddition.additional_info.expendable_date === '')
            {
                this.delegateWithAddition.additional_info.expendable_date = null;
            }
            if(this.delegateWithAddition.additional_info.catheter_date === '')
            {
                this.delegateWithAddition.additional_info.catheter_date = null;
            }


            this.delegateWithAddition.additional_info.electrode_first = this.electrode_first;

            this.$store.dispatch(Constant.SAVE_DELEGATE_ADDTION, {profile_id: this.diabetes_profiles[this.activeProfileId].profile.id, token: this.token})
                .then(() => {
                    this.setFloatingMessage("저장되었습니다.")
                    this.$store.dispatch(Constant.FETCH_PROFILES, {token: this.token})
                        .then(() => {
                            this.isLoading = false;
                        }) 
                        .catch(() => {
                            this.token = cookies.deleteLocalStorage("access_token");
                            this.isLoading = false;
                            this.$router.push({path: '/', query: {returnUrl: 'apply'}})
                        })
                })
                .catch((err) => {
                    this.error = err;
                    this.isLoading = false;
                })

        },       
        back: function()
        {
            this.$router.push('/home')
        },
        closeFloating: function()
        {
            this.isFloating = false;
        },
        setFloatingMessage: function(message)
        {
            this.floatingMessage = message
            this.isFloating = true;

            setTimeout(() => {
                this.isFloating = false;
            }, 2000); // 2초 후 메시지 숨김
        }
    },
    watch: {
        activeProfileId() {
            this.selectedTabIndex = 0;
            
        },
        selectedTabIndex() {
            if(this.selectedTabIndex === 1)
            {  
                this.duplicateDelegation = false;
                this.expireDelegation = false;
                if(this.diabetes_profiles[this.activeProfileId].delegation_info !== null && this.diabetes_profiles[this.activeProfileId].delegation_info.is_delegated)
                {
                    // 이미 
                    if(this.diabetes_profiles[this.activeProfileId].delegation_info.expired_at)
                    {
                        let cur = new Date();
                        let expire = new Date(this.diabetes_profiles[this.activeProfileId].delegation_info.expired_at);
                        expire.setDate(expire.getDate() - 30);
                        if(cur >= expire)
                        {
                            this.duplicateDelegation = true;  // 만료 예정
                        }

                        expire = new Date(this.diabetes_profiles[this.activeProfileId].delegation_info.expired_at);
                        expire.setDate(expire.getDate());
                        if(cur > expire)
                        {
                            this.duplicateDelegation = false;
                            this.expireDelegation = true;  // 만료 
                        }
                    }
                }
            }
            else if(this.selectedTabIndex === 2)
            {
                // data 넣기
                if(this.diabetes_profiles[this.activeProfileId].addition_info == null)
                {
                    this.selectedSaleType = 0;
                    this.expendable_date = null
                    this.electrode_date = null
                    this.catheter_date = null
                    this.useAutoInjector = false
                    this.electrode_first = false
                }
                else
                {
                    const type = this.diabetes_profiles[this.activeProfileId].addition_info.person_type;
                    this.selectedSaleType = type === null ? 0 : type === 'NATIONAL_BASIC' ? 1 : type === '' ? 0 : 2
                    this.expendable_date = this.diabetes_profiles[this.activeProfileId].addition_info.expendable_date
                    this.electrode_date = this.diabetes_profiles[this.activeProfileId].addition_info.electrode_date
                    this.useAutoInjector = this.diabetes_profiles[this.activeProfileId].addition_info.is_injection_insulin
                    this.electrode_first = this.diabetes_profiles[this.activeProfileId].addition_info.electrode_first
                    this.catheter_date = this.diabetes_profiles[this.activeProfileId].addition_info.catheter_date
                }

            }
        },
        'phoneNumber': function() {
            this.phoneError = null
        },
        expendable_date: function()
        {
            this.expendable_date = this.normalizeToYYYYMMDDOrKeep(this.expendable_date)
        },
        electrode_date: function()
        {
            this.electrode_date = this.normalizeToYYYYMMDDOrKeep(this.electrode_date)
        },
        catheter_date: function()
        {
            this.catheter_date = this.normalizeToYYYYMMDDOrKeep(this.catheter_date)
        }
    }
}
</script>

<style scoped>
    .wrapper {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .page {
        width: 100%;
        background: var(--Gray-20, #F3F5F8);
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        box-sizing: border-box;
    }

    @media (min-width: 600px) {
        .page {
            width: 600px;
        }
    }

    .contents-header {
        width: 100%;
        padding: 0 16px 30px 16px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        box-sizing: border-box;
    }
    .text1 {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 24px;
        font-style: normal;
        font-weight: 600;
        line-height: 26px; /* 108.333% */
    }
    .text2 {
        color: var(--Gray-60, #6B7684);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 122.222% */
    }
    .text3 {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: 22px;
    }
    .contents-body {
        padding: 20px 16px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        width: 100%;
        background: var(--Gray-00, #FFF);
    }
    .register-button {
        border-radius: 6px;
        background: #6B7684;
        width: 100%;
        height: 39px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 9px 0 16px;
        box-sizing: border-box;
        cursor: pointer;
    }
    .row {
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .col {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
    }
    .text4 {
        color: var(--Gray-primary-color2, #FFF);
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: 14px;
        letter-spacing: -0.32px;
    }
    .text5 {
        color: var(--gray-30-stroke, #E8EAEE);
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 14px; /* 87.5% */
        letter-spacing: -0.32px;
    }
    .text6 {
        color: #1E1E1E;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }
    .text7 {
        color: #184FA1;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 122.222% */
    }
    .name-button-list {
        display: flex;
        width: 100%;
        justify-content: flex-start;
        align-items: center;
        overflow-x: scroll;
    }
    .name-button-active {
        width: 104px;
        height: 53px;
        border-radius: 6px;
        background: #184FA1;
        color: var(--Gray-00, #FFF);
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .name-button-inactive {
        width: 104px;
        height: 53px;
        border-radius: 6px;
        background: var(--Gray-sub-color1, #F3F5F8);
        color: #1E1E1E;
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .input-big {
        width: 100%;
        height: 48px;
        color: var(--Gray-50, #A3AAB6);
        font-family: Pretendard;
        font-size: 18px;
        padding-left: 16px;
        padding-right: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        border-radius: 6px;
        box-sizing: border-box;
    }
    input::placeholder {
        color: var(--Gray-50, #A3AAB6);
    }
    .info-text {
        color: var(--Gray-50, #A3AAB6);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 111.111% */
    }
    .info-color-text {
        color: #184FA1;
    }
    .card-area {
        width: 100%;
        border-radius: 6px;
        background: var(--Gray-20, #F3F5F8);
        box-sizing: border-box;
        padding: 20px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
    }
    .card-update-button {
        display: flex;
        height: 36px;
        padding: 0 16px;
        justify-content: center;
        align-items: center;
        flex-shrink: 0;
        border-radius: 100px;
        border: 1px solid var(--gray-40-button-stroke, #D1D6DB);
        background: var(--Gray-00, #FFF);
        color: #1D4A94;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        cursor: pointer;
    }
    .diabetes_type_text {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 122.222% */
    }
    .button-wrapper {
        width: 100%;
    }
    .button-header {
        width: 100%;
        height: 75px;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        padding: 20.32px 15.5px;
        box-sizing: border-box;
    }
    .plus-button {
        border-radius: 10px;
        border: 1px dashed var(--Gray-50, #A3AAB6);
        background: var(--Gray-20, #F3F5F8);
        width: 100%;
        color: var(--Gray-100, #1E1E1E);
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: 18px; /* 100% */
        display: flex;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        height: 62px;
        cursor: pointer;
    }
    .line {
        width: calc(100% + 32px);
        margin-left: -16px;
        background: var(--Gray-sub-color1, #F3F5F8);
        height: 8px;
        margin: 20px 0 0 -16px;
    }
    .save-button {
        border-radius: 6px;
        background: #184FA1;
        display: flex;
        width: 72px;
        height: 42px;
        justify-content: center;
        align-items: center;
        color: var(--Gray-00, #FFF);
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        cursor: pointer;
    }
    /*  */
    .title {
        color: #1E1E1E;
        font-family: Pretendard;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }
    .text-box {
        width: 100%;
        flex-shrink: 0;
        border-radius: 6px;
        background: var(--Gray-20, #F3F5F8);
        padding: 20px;
        margin-top: 16px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
        letter-spacing: -0.36px;
    }
    .text {
        color: #184FA1;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 122.222% */
        letter-spacing: -0.36px;
        margin-top: 8px;
    }
    .label {
        color: #1E1E1E;
        font-family: Pretendard;
        font-size: 20px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .text-20-400-1E1E1E {
        color: #1E1E1E;
        font-family: Pretendard;
        font-size: 20px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }
    .text-20-600-1E1E1E {
        color: #1E1E1E;
        font-family: Pretendard;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }
    .text-18-400-1E1E1E {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }
    .input-calendar-wrapper {
        position: relative;
        width: 100%;
        max-width: 568px;
    }
    .input-calendar {
        border: 0;
        border-radius: 6px;
        background: var(--Gray-20, #F3F5F8);
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        cursor: pointer;
        height: 48px;
        padding: 16px 40px 16px 15px;
        box-sizing: border-box;
        width: calc(100%);
        max-width: calc(568px);
    }
    .clear-btn {
        position: absolute;
        right: 12px;
        top: 50%;
        transform: translateY(-50%);
        width: 24px;
        height: 24px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        color: #A3AAB6;
        font-size: 24px;
        font-weight: 300;
    }
    .input-calendar::placeholder {
        color: var(--Gray-50, #A3AAB6);
    }

    @supports (-webkit-touch-callout: none) {
        input[type="date"] {
            height: 48px;
            width: calc(100% - 32px);
            max-width: calc(568px);
            line-height: 48px;   /* 🔥 핵심 */
            padding: 0 12px;
            box-sizing: border-box;
            font-size: 18px;     /* iOS 줌 방지 + 안정화 */
        }
    }


    .floating {
        width: calc(100% - 32px);
        max-width: calc(568px);
        position: fixed;
        z-index: 999;
        border-radius: 6px;
        background: var(--Gray-60, #6B7684);
        backdrop-filter: blur(2px);
        height: 57px;
        left: 50%;
        bottom: 32px;
        transform: translate(-50%, 0);
        padding: 0 30px 0 20px;
        box-sizing: border-box;
        color: #FFF;
        font-family: Pretendard;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .close {
        position: absolute;
        top: 17px;
        right: 8px;
        width: 22px;
        cursor: pointer;
    }
    .error-info-text {
        color: var(--Semantic-01_Red, #FF000F);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 122.222% */
        margin-top: 8px;
    }

    .text-red {
        color: var(--Semantic-01_Red, #FF000F);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: 24px; /* 133.333% */
        letter-spacing: -0.36px;
    }
    .text-normal {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
        letter-spacing: -0.36px;
    }
    .red-tag {
        display: flex;
        padding: 5px 8px;
        box-sizing: border-box;
        justify-content: center;
        align-items: center;
        border-radius: 3px;
        background: var(--Gray-00, #FFF);
        color: var(--Semantic-01_Red, #FF000F);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }
    .black-tag {
        display: flex;
        padding: 5px 8px;
        box-sizing: border-box;
        justify-content: center;
        align-items: center;
        border-radius: 3px;
        background: var(--Gray-100, #1E1E1E);
        color: var(--Gray-00, #FFF);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }
</style>


// WEBPACK FOOTER //
// src/page/Apply.vue